// src/belediye/components/mesajlasma/SohbetListesi.js
//
// FAZ-94 — SOHBET LİSTESİ, TEK GÖVDE.
//
// Telefonda mesajlaşma bir ROTA oldu (`/yonetim/sohbet`); tablet ve masaüstünde
// yüzen pencere (ChatDock) aynen duruyor. İki kap, tek liste: satır çizimi,
// tür ikonu, önizleme, okunmamış rozeti burada — kopya yok.
//
// Kap farkı yalnız ÜST BÖLGEDE:
//   dock  → kendi "Sohbetler + Yeni" başlığı ve çipleri kendi içinde çizer
//   sayfa → başlık navbarda, çipler PageHeader'ın yapışkan kabında; buraya
//           yalnız kayan liste kalır (bkz. pages/sohbet/SohbetlerPage.js)
//
// Riskin adı (FAZ-94 §9): "iki ayrı sohbet uygulaması". Bu dosya o riskin
// panzehiri — mantık tek yerde, değişen yalnız çerçeve.

import React from "react";
import { ChatBubbleLeftRightIcon, LinkIcon } from "@heroicons/react/24/outline";

import { TaskIcon, conversationIcon, conversationLabel } from "../icons/appIcons";
import Avatar from "./Avatar";

import { convKind, filterConvsBySegment } from "./sohbetKovalari";

const trWhen = (v) => {
  if (!v) return "";
  const d = new Date(v);
  const bugun = new Date().toDateString() === d.toDateString();
  return bugun
    ? d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit" });
};

/**
 * @param {Array|null} convs      null = yükleniyor
 * @param {string} segment        seçili segment anahtarı
 * @param {string} gorevAlt       Talepler alt süzgeci
 * @param {number|null} aktifId   seçili sohbet (dock'ta sağ panede açık olan)
 * @param {Function} onAc         satıra tıklanınca (conv nesnesi)
 * @param {Function} onScroll     kaydırma (dock'ta başlık gizleme bayrağı)
 */
export default function SohbetListesi({
  convs,
  segment,
  gorevAlt = "acik",
  aktifId = null,
  onAc,
  onScroll,
  className = "",
}) {
  const gorunur = filterConvsBySegment(convs, segment, gorevAlt);

  return (
    <div
      className={["msj-list-scroll", className].filter(Boolean).join(" ")}
      onScroll={onScroll}
    >
      {convs === null && <div className="msj-empty">Yükleniyor…</div>}

      {convs !== null && convs.length === 0 && (
        <div className="msj-empty">
          <ChatBubbleLeftRightIcon className="msj-empty-icon" />
          Henüz sohbet yok. "Yeni" ile başlatın.
        </div>
      )}

      {convs !== null && convs.length > 0 && gorunur.length === 0 && (
        <div className="msj-empty">Bu sekmede sohbet yok.</div>
      )}

      {gorunur.map((c) => {
        const tur = convKind(c); // dm | grup | gorev | basvuru
        return (
          <div
            key={c.id}
            role="button"
            tabIndex={0}
            className={`msj-conv msj-conv--${tur} ${
              aktifId === c.id ? "is-active" : ""
            }`}
            onClick={() => onAc(c)}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onAc(c)}
          >
            {/* FAZ-51: sohbet türü ikondan okunur. Eskiden görev, başvuru ve
                grup sohbetlerinin ÜÇÜ de aynı çift balonla çiziliyordu →
                liste içinde türü ayırt etmek imkânsızdı. */}
            {c.kind === "dogrudan" ? (
              <Avatar name={c.title} src={c.avatar} size={40} />
            ) : (
              (() => {
                // Başvuru sohbeti backend'de kind="gorev" olabildiği için ham
                // `c.kind` değil TÜRETİLMİŞ tür kullanılır.
                const KindIcon = conversationIcon(tur);
                return (
                  <span
                    className={`msj-conv-groupava msj-conv-groupava--${tur}`}
                    title={conversationLabel(tur)}
                  >
                    <KindIcon width={22} />
                  </span>
                );
              })()
            )}
            <span className="msj-conv-main">
              <span className="msj-conv-top">
                <span className="msj-conv-title">{c.title}</span>
                <span className="msj-conv-when">{trWhen(c.updated_at)}</span>
              </span>
              {c.last_message && (
                <span className="msj-conv-preview">
                  {c.last_message.author_display
                    ? `${c.last_message.author_display}: `
                    : ""}
                  {c.last_message.body}
                </span>
              )}
              {tur === "basvuru" ? (
                <span className="msj-topic msj-topic--basvuru">
                  <LinkIcon width={12} /> Başvuru #{c.topic_ref.application_tracking}
                </span>
              ) : tur === "gorev" ? (
                <span className="msj-topic msj-topic--gorev">
                  <TaskIcon width={12} /> Talep
                </span>
              ) : null}
            </span>
            {c.unread > 0 && (
              <span className="msj-conv-unread">
                {c.unread > 99 ? "99+" : c.unread}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
